<script lang="ts" setup>
</script>
<template>
  <main id="main" class="password">
    <SfTile large>
      <template #title>
        <h1 class="account-heading">
          {{ $t('SHOP.AUTH.HEADER.RESET_PASSWORD') }}
        </h1>
      </template>
      <template #default>
        <FormController v-slot="{ submit, processing }" :action="$route('web.account.password.forgotten.store')" method="POST">
          <div class="password__inputs">
            <SfFormInput :label="$t('SHOP.AUTH.LABEL.EMAIL')" name="email" required />
            <div class="password__buttons-wrapper">
              <SfButton :href="$route('web.account.session.create')">
                {{ $t('SHOP.ACTION.CANCEL') }}
              </SfButton>
              <SfButton :loading="processing" primary type="submit" @click="submit">
                {{ $t('SHOP.AUTH.ACTION.RESET_PASSWORD') }}
              </SfButton>
            </div>
          </div>
        </FormController>
      </template>
    </SfTile>
  </main>

  <RouterView />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .password {
    width: 98%;
    max-width: 600px;
    margin: 100px auto;

    &__inputs {
      display: flex;
      flex-direction: column;
      row-gap: 1.5rem;
    }

    &__buttons-wrapper {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
    }
  }

  @include media.query(lg) {
    .password {
      align-items: stretch;

      &_header {
        justify-content: center;
      }

      &__buttons-wrapper {
        flex-direction: column;
      }
    }
  }
</style>
